import { Navigate } from "react-router-dom";
import { ADMIN_LESSONS_ROUTE, HOME_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { FEATURES, hasFeature } from "../../entities/my";
import { LayoutPages } from "../layoutPages";
import { AdminLessons } from "../../widgets/adminLessons";

export default function AdminLessonsPage() {

    const {my} = useAppSelector(s => s.myReducer)

    const isAccess = hasFeature(my, FEATURES.LESSONS.LIST)
    
    if(!isAccess){
        return (
            <Navigate to={HOME_ROUTE.path} replace />
        )
    }

    return (
        <LayoutPages title={ADMIN_LESSONS_ROUTE.name}>
            <AdminLessons />
        </LayoutPages>
    )
}
